/* assets/department-filter-prefs.js */
(function (w, d) {
  const STORAGE_KEY = 'deptfilter.selectedDepts.v1';
  const OPTION_KEY = 'filter.p.m.custom.abteilung'; // Metafield-Filter (Search & Discovery), unencoded

  function safeLocalStorage() {
    try { const t='__t'; localStorage.setItem(t,'1'); localStorage.removeItem(t); return localStorage; }
    catch(e){ return null; }
  }
  const ls = safeLocalStorage();
  const mem = { value: [] };

  const store = {
    get() {
      try {
        const raw = ls ? ls.getItem(STORAGE_KEY) : null;
        const arr = raw ? JSON.parse(raw) : mem.value;
        return Array.isArray(arr) ? Array.from(new Set(arr)).filter(Boolean) : [];
      } catch(e){ return []; }
    },
    set(depts) {
      const clean = Array.from(new Set((depts||[]).map(s => String(s).trim()).filter(Boolean)));
      if (ls) ls.setItem(STORAGE_KEY, JSON.stringify(clean));
      else mem.value = clean;
      d.dispatchEvent(new CustomEvent('deptfilter:stored', { detail: { depts: clean }}));
      return clean;
    },
    clear() {
      if (ls) ls.removeItem(STORAGE_KEY);
      mem.value = [];
      d.dispatchEvent(new CustomEvent('deptfilter:stored', { detail: { depts: [] }}));
    }
  };

  // Kollektionen ohne Größen-/Abteilungslogik (Accessoires, Handtaschen etc.) – dort darf
  // kein gespeicherter Filter angehängt werden, sonst gibt's dort fälschlich 0 Treffer.
  // Wird von toolbar.liquid gesetzt, dort liegt auch die eigentliche Ausschlussliste.
  function isExcludedCollectionUrl(url) {
    try {
      const u = new URL(url, location.origin);
      if (!u.pathname.startsWith('/collections/')) return false;
      const handle = u.pathname.split('/collections/')[1]?.split('/')[0]?.split('?')[0];
      const excluded = w.SizeDeptFilterExcludedCollections || [];
      return excluded.includes(handle);
    } catch (e) { return false; }
  }

  function appendFiltersToUrl(url, depts) {
    if (!depts || !depts.length) return url;
    if (isExcludedCollectionUrl(url)) return url;
    try {
      const u = new URL(url, location.origin);
      if (!u.pathname.startsWith('/collections/')) return url;

      const existing = u.searchParams.getAll(OPTION_KEY);
      const merged = Array.from(new Set([...existing, ...depts]));
      u.searchParams.delete(OPTION_KEY);
      merged.forEach(v => u.searchParams.append(OPTION_KEY, v));

      if (!u.searchParams.has('sort_by')) u.searchParams.append('sort_by','manual');
      return u.pathname + (u.search ? '?' + u.searchParams.toString() : '');
    } catch(e) { return url; }
  }

  function enhanceCollectionLinks() {
    const depts = store.get();
    if (!depts.length) return;
    const sel = 'a[href*="/collections/"]';
    d.querySelectorAll(sel).forEach(a => {
      if (a.dataset.deptfilterEnhanced === 'true') return;
      const href = a.getAttribute('href');
      if (!href) return;
      a.setAttribute('href', appendFiltersToUrl(href, depts));
      a.dataset.deptfilterEnhanced = 'true';
    });
  }

  function autoApplyOnCollection() {
    const ENABLED = true;
    if (!ENABLED) return;

    const isCollection = location.pathname.startsWith('/collections/');
    if (!isCollection) return;

    const depts = store.get();
    if (!depts.length) return;

    const sp = new URLSearchParams(location.search);
    if (sp.getAll(OPTION_KEY).length) return; // User hat schon Filter in der URL

    const newUrl = appendFiltersToUrl(location.href, depts);
    if (newUrl !== location.href) {
      location.replace(newUrl);
    }
  }

  // UI -> Storage: höre auf Custom Event aus dem Toolbar-UI
  d.addEventListener('deptfilter:change', (ev) => {
    const arr = Array.isArray(ev.detail?.depts) ? ev.detail.depts : [];
    store.set(arr);
    enhanceCollectionLinks();
  });

  function init() {
    enhanceCollectionLinks();
    // Hinweis: das automatische Anwenden gespeicherter Filter beim Kollektionswechsel
    // passiert zentral in toolbar.liquid (per AJAX, ohne Reload) – hier NICHT mehr
    // per location.replace() auslösen, sonst gibt es bei mehreren aktiven Filtergruppen
    // (Größe + Abteilung) mehrfache, sich überschneidende Reloads.
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init);
  else init();

  const mo = new MutationObserver(() => enhanceCollectionLinks());
  mo.observe(d.documentElement, { childList: true, subtree: true });

  w.DeptFilterPrefs = {
    getSelectedDepts: store.get,
    setSelectedDepts: store.set,
    clearSelectedDepts: store.clear,
    OPTION_KEY
  };
})(window, document);
